import React, { useState, useEffect } from "react";
import { useAuth } from "../../../usercontext";
import GlobalStudentActivityList from "../../pages/common/globalstudentactivitylist";
import STopMenu from "../../../components/student/topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import S12TopMenu from "../../student12/topmenu/topmenu";
import PageNotes from '../../pages/common/pagenotesnew'

export default function StudentActivityList() {
	const { profile } = useAuth()
	const slug = profile.id
	const isStudent911 = profile?.role === 'Student911'
	const isStudent12 = profile?.role === 'Student12'
	const isStudent = profile?.role === 'Student'
	return (
		<>
			{isStudent && <STopMenu slug={slug} activeMenu="Activities" />}
			{isStudent911 && <S911TopMenu slug={slug} activeMenu="Activities" />}
			{isStudent12 && <S12TopMenu slug={slug} activeMenu="Activities" />}
			<PageNotes type={'Student'} studentId={slug} />
			<GlobalStudentActivityList slug={slug} isStudent={true} studentRole={profile?.role} />
		</>
	)
}
